import { MessageService } from 'primeng/api';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PermissionInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.Forbidden) {
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('tooltip.error'),
            detail: err.error.Message || this.translateService.instant('userPermissions.forbidden'),
            life: 4000,
          });
          console.error('Forbidden error intercepted:', err);

          this.router.navigate(['/my-catalog']);

          return EMPTY;
        }

        return throwError(() => err);
      })
    );
  }
}
